import { useState } from "react";
import References from "../../helpers/Reference";
import { ExportModalWindow } from "./components/export-modal-window";

import { loadAnalytics, parseAnalytics, DownloadCSV, ShowLocaleDateTime, ShowLocaleDate } from "../../helpers/helpers";
import iconv from 'iconv-lite';

const HIDDEN_ON_TITLES = ['sum'];

export const ExportAggregateData = ( {start, finish, station, measurer, aggregate, onClose} ) => {

    const [ isOpen, setIsOpen ] = useState( true );

    const onExport = (encoding, sep, decSep) => {
        loadAnalytics( measurer.uuid, measurer.type, start, finish, aggregate )
        .then( response => {
            let data = parseAnalytics( measurer.type, response );            
            if (data.length > 0) {

                const colSep = sep === "59" ? ";" : "\t";
                const measurerRef = References.mchs[measurer.type];
                const prec = isNaN(measurerRef?.analytic?.precision) ? measurerRef.precision : measurerRef?.analytic?.precision;
                const unit = measurerRef?.analytic?.unit ? measurerRef.analytic.unit : measurerRef.unit;

                const measurerName = measurerRef?.agg_name || measurerRef?.short_name || measurerRef.name;   
                const datasets = data[0].datasets;
                            
                let csv = `${References.dictionary.time}(${References.dictionary.agg[aggregate]})`;
                datasets.forEach((item) => {
                    csv += `${colSep}${measurerName}, ${unit}`;

                    //для некоторых агрегаций не показываем их название
                    if (HIDDEN_ON_TITLES.indexOf(item) === -1)
                        csv += ` (${References.dictionary[item]})`;
                });            
                csv += '\n';

                data.forEach((item) => {
                    csv += `${GetAggregateExportDate(item.x, aggregate)}`;
                    datasets.forEach((dataset) => {
                        csv += `${colSep}${GetAggregateExportValue(item, dataset, prec)}`;
                    })
                    csv += '\n';
                })

                if (encoding === 'windows-1251') { 
                    csv = iconv.encode(csv, "cp1251", {    
                        stripBOM: true,
                        addBOM: true,
                        defaultEncoding: 'win1251'}
                    );
                }
                DownloadCSV( csv, `${measurer.typeName}_${station.name}`, encoding, onFinish );

            }

    
        })

    }

    const onFinish = () => {
        setIsOpen(false);
        onClose();
    }

    return (
        <ExportModalWindow 
            onExport={onExport}
            onCancel={onFinish}
            opened={isOpen}
        />
    );
}

const GetAggregateExportDate = ( date, aggregate) => {
    return aggregate !== '12H' ? ShowLocaleDate( date ) : ShowLocaleDateTime( date );
}

const GetAggregateExportValue = ( values, dataset, prec ) => {
    if (!values.hasOwnProperty(dataset))
        return '';

    const value = parseFloat(values[dataset]);
    if (isNaN(value))
        return '';

    return value.toFixed(prec).toString();
}